var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"ar-waiting-for-tv-page"}},[_c('WaitingForTv')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }